import type { FC } from "react";
import { DashboardTimelinePreview } from "web_myplann/Dashboard/Components/DashboardTimelinePreview";
import { useDashboardUpcomingPreview } from "web_myplann/Dashboard/Hooks/useDashboardUpcomingPreview";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { TimelineEntry } from "web_myplann/NotificationCenter/Components/TimelineEntry";
import { NOTIFICATION_CENTER_TABS } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import { useNavigateFromTimelineItem } from "web_myplann/NotificationCenter/Hooks/useNavigateFromTimelineItem";
import { DASHBOARD_ORIGIN } from "web_myplann/NotificationCenter/Utils/notificationOrigin";

interface DashboardUpcomingSectionProps {
	onEmptyChange?: (isEmpty: boolean) => void;
}

export const DashboardUpcomingSection: FC<DashboardUpcomingSectionProps> = ({
	onEmptyChange,
}) => {
	const { t } = useResource();
	const preview = useDashboardUpcomingPreview();
	const navigateToItem = useNavigateFromTimelineItem({
		origin: DASHBOARD_ORIGIN,
	});

	return (
		<DashboardTimelinePreview
			title={t(Resources.Dashboard.NotificationSections.Upcoming)}
			items={preview.items}
			hasMore={preview.hasMore}
			isLoading={preview.isLoading}
			showAllTab={NOTIFICATION_CENTER_TABS.Upcoming}
			ItemComponent={TimelineEntry}
			testId="dashboard-upcoming"
			onItemClick={navigateToItem}
			onEmptyChange={onEmptyChange}
		/>
	);
};
